export default "__VITE_ASSET__wOOf0WX9__"